/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Agent_3_TitleInputs */

const en_mk_agent_3_title = /** @type {(inputs: Mk_Agent_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mention an agent in a channel, it answers in the thread`)
};

const id_mk_agent_3_title = /** @type {(inputs: Mk_Agent_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sebut agen di channel, ia menjawab di thread`)
};

/**
* | output |
* | --- |
* | "Mention an agent in a channel, it answers in the thread" |
*
* @param {Mk_Agent_3_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_agent_3_title = /** @type {((inputs?: Mk_Agent_3_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Agent_3_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_agent_3_title(inputs)
	return en_mk_agent_3_title(inputs)
});